'use client';

import BenefitCardGrid from '@/app/(football)/[team]/_components/common/BenefitCardGrid';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import SectionHeader from '@/app/(football)/[team]/main/_components/Section/SectionHeader';

export default function TopCollectorSection() {
  const { teamSlug, topCollector } = useTeamConfig();

  const useSecondSeasonImages =
    topCollector.currentSeason === 'second_top_collector' &&
    Boolean(topCollector.hasSecondSeasonBenefitImages);

  return (
    <section className="flex w-full flex-col items-center gap-5 px-5 pb-16">
      <SectionHeader linkUrl={`/${teamSlug}/top-collector`} color="--color-g-00">카드 모으면 보상은 덤, 탑콜렉터</SectionHeader>

      <BenefitCardGrid teamSlug={teamSlug} useSecondSeasonImages={useSecondSeasonImages} />
    </section>
  );
}
